(function (window) {
  var strings = BatchGeoStrings.getStringsForComponent("BatchGeoStoreLocator");

  /**
   * BatchGeoStoreLocatorSearch is a simple component to wrap up the search
   * functionality in the Store Locator. It creates the "form" and attaches an
   * omnibox component to it. It then provides a this.$elements to allow other
   * components to access the most commonly accessed elements to append or get
   * the values of (example: mySearchInstance.$elements.$input.val())
   *
   * @example
   * mySearch = new BatchGeoStoreLocatorSearch();
   * $someSubmitButton.on('click', function () {
   *   console.log(mySearch.$elements.$input.val())
   * })
   */
  var BatchGeoStoreLocatorSearch = function () {
    this._cacheElements();

    this.omniboxInstance = new BatchGeoOmnibox({
      container: this.getElements().$wrapper,
      omniboxInput: this.getElements().$input,
    });
  };

  /**
   * Gives back the elements making up the search form. This includes:
   *
   * - $input: The actual input. You can get the search term the user looked
   *   for from this.
   * - $icon: The magnifying glass icon. You can use this if you want to show
   *   or hide the icon in certain instances.
   * - $wrapper: An element containing everything for the search including
   *   elements not listed here. Use this to inject into the DOM.
   *
   * @return {{$input: jQuery, $icon: jQuery, $wrapper: jQuery}}
   */
  BatchGeoStoreLocatorSearch.prototype.getElements = function () {
    return this.$elements;
  };

  /**
   * Creates and caches the search form elements. It will create the search
   * input (as $input), the search icon ($icon), and the overall wrapper (as
   * $wrapper) which is a form element.
   *
   * This is private but you can publicly access via #getElements().
   *
   * @private
   */
  BatchGeoStoreLocatorSearch.prototype._cacheElements = function () {
    this.$elements = {
      $input: $("<input />", {
        addClass: "storeLocator-search-input",
        placeholder: strings.get("SEARCH_INPUT_PLACEHOLDER"),
      }),
      $icon: $("<label />", {
        addClass: "storeLocator-search-input-icon toolbar-icon-search",
      }),
    };

    this.$elements.$wrapper = $("<form />", {
      addClass: "storeLocator-search-wrapper",
      html: [this.$elements.$icon, this.$elements.$input],
    });
  };

  window.BatchGeoStoreLocatorSearch = BatchGeoStoreLocatorSearch;
})(window);
